import { IconType } from "react-icons/lib";
import { cn } from "utils/helpers";

export interface BaseIconBoxProps {
	children?: React.ReactNode;
	className?: string;
}

interface IconBoxProps extends BaseIconBoxProps {
	borderColor: string;
	iconFill: string;
	iconStroke?: string;
	icon?: IconType;
}

export const IconBox = ({ borderColor, children, className, iconFill, iconStroke, icon: Icon }: IconBoxProps) => {
	return (
		<div>
			<div className="relative top-4">
				<Icon size={24} className={cn(iconFill, iconStroke ?? "stroke-white")} />
			</div>
			<div
				className={cn("mx-2 rounded-md border-2 p-3", borderColor, className)}
			>
				{children}
			</div>
		</div>
	);
};
